// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder_placeholder__6w0w1","glow":"Placeholder_glow__A-WEE","placeholder-glow":"Placeholder_placeholder-glow__7Uzuk","inline":"Placeholder_inline__oUjXe"};